import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgSelectModule } from '@ng-select/ng-select';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NavComponent } from './nav/nav.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HomeComponent } from './home/home.component';
import { RegisterComponent } from './register/register.component';
import { MemberListComponent } from './members/member-list/member-list.component';
import { MemberDetailComponent } from './members/member-detail/member-detail.component';
import { ListsComponent } from './lists/lists.component';
import { MessagesComponent } from './messages/messages.component';
import { SharedModule } from './_modules/shared.module';
import { TestErrorsComponent } from './errors/test-errors/test-errors.component';
import { ErrorInterceptor } from './_interceptors/error.interceptor';
import { NotFoundComponent } from './errors/not-found/not-found.component';
import { ServerErrorComponent } from './errors/server-error/server-error.component';
import { MemberCardComponent } from './members/member-card/member-card.component';
import { JwtInterceptor } from './_interceptors/jwt.interceptor';
import { MemberEditComponent } from './members/member-edit/member-edit.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { LoadingInterceptor } from './_interceptors/loading.interceptor';
import { TextInputComponent } from './_forms/text-input/text-input.component';
import { DateInputComponent } from './_forms/date-input/date-input.component';
import { AdminPanelComponent } from './admin/admin-panel/admin-panel.component';
import { SecuritycodeComponent } from './securitycode/securitycode/securitycode.component';
import { ThankyouComponent } from './thankyou/thankyou/thankyou.component';
import { PricelistComponent } from './pricelist/pricelist.component';
import { BasketComponent } from './basket/basket.component';
import { ImportComponent } from './import/import.component';
import { ProfileComponent } from './profile/profile.component';
import { DownloadComponent } from './download/download.component';
import { OrdersendComponent } from './ordersend/ordersend.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { OrderhistoryComponent } from './orderhistory/orderhistory.component';
import { PromotionComponent } from './promotion/promotion.component';
import { StyleDirective } from './_directives/style.directive';
import {MatTabsModule} from '@angular/material/tabs';
import { DialogModule } from '@angular/cdk/dialog'; 

@NgModule({ declarations: [
        AppComponent,
        NavComponent,
        HomeComponent,
        RegisterComponent,
        MemberListComponent,
        MemberDetailComponent,
        ListsComponent,
        MessagesComponent,
        TestErrorsComponent,
        NotFoundComponent,
        ServerErrorComponent,
        MemberCardComponent,
        MemberEditComponent,
        TextInputComponent,
        DateInputComponent,
        AdminPanelComponent,
        SecuritycodeComponent,
        ThankyouComponent,
        PricelistComponent,
        BasketComponent,
        ImportComponent,
        ProfileComponent,
        DownloadComponent,
        OrdersendComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent,
        OrderhistoryComponent,
        PromotionComponent,
        StyleDirective
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        NgxSpinnerModule,
        NgSelectModule,
        MatTabsModule,
        DialogModule], providers: [
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
